import React from "react";

export function MobileIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="2"
        width="10"
        height="16"
        rx="2"
        stroke="#555"
        strokeWidth="1.5"
        fill="#fff"
      />
      <circle cx="10" cy="16" r="1" fill="#555" />
    </svg>
  );
}
